import Base from "@/api/Base";

export default class GetList extends Base
{
	setJobProfileId (v)
	{
		this.jobProfileId = v;
		return this;
	}

	setJobId (v)
	{
		this.data.jobId = v;
		return this;
	}

	setOnlyFavorites (v)
	{
		this.data.onlyFavorites = v;
		return this;
	}

	setGroupOnly (v)
	{
		this.data.groupOnly = v;
		return this;
	}

	setFuzzyType (v)
	{
		this.data.fuzzyType = v;
		return this;
	}

	setFilterGroups (v)
	{
		this.data.filterGroups = v;
		return this;
	}

	setOffset (v)
	{
		this.data.offset = v;
		return this;
	}

	setLimit (v)
	{
		this.data.limit = v;
		return this;
	}

	getMethod ()
	{
		return 'GET';
	}

	getUrl ()
	{
		return '/kunde/stellenprofil/' + this.jobProfileId + '/person';
	}
}
